import { render } from "./PdfViewer.vue?vue&type=template&id=d8b7fb62&ts=true"
import script from "./PdfViewer.vue?vue&type=script&lang=ts"
export * from "./PdfViewer.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__